import { Injectable } from '@angular/core';
import { Functions } from '@angular/fire/functions';
import { IObjectKey } from '@nova/common-interfaces';
import { FUNCTION_NAME, IServicePlan } from '@rfm/shared-interfaces';
import { CommonService } from '../../../../lib/services/index.mjs';

@Injectable({
  providedIn: 'root',
})
export class ServicePlanService extends CommonService<IServicePlan, IObjectKey> {
  public override deleteFunctionName: FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SERVICEPLAN_REMOVE;
  public override insertFunctionName: FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SERVICEPLAN_INSERT;
  public override mergeFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SERVICEPLAN_MERGE;
  public override updateFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SERVICEPLAN_UPDATE;
  public override getAllFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SERVICEPLAN_GETALL;
  public override getFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SERVICEPLAN_GET;
  public override getKeysFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SERVICEPLAN_GETKEYS;

  constructor(functions: Functions) {
    super(functions);
  }
}
